<div class="auth-page bg-auth">
  <div class="container">
    <div class="row justify-content-center">
      <div class="col-12 col-md-5 col-xl-4 my-5">

        <div class="text-center mb-4"><span class="brand-badge">🎫</span></div>
        <h1 class="display-4 text-center mb-3">Entrar</h1>
        <p class="text-muted text-center mb-5">
          {{ returning() ? 'Entre para continuar onde estava.' : 'Entre com o seu e-mail de trabalho' }}
        </p>

        <form [formGroup]="form" (ngSubmit)="submit()">
          <div class="form-group">
            <label class="form-label">E-mail</label>
            <input class="form-control" type="email" formControlName="email" placeholder="voce@empresa.com" />
            @if (form.controls.email.touched && form.controls.email.invalid) {
              <small class="text-danger">Indique um e-mail válido.</small>
            }
          </div>

          <div class="form-group">
            <label class="form-label">Palavra-passe</label>
            <input class="form-control" type="password" formControlName="password" placeholder="A sua palavra-passe" />
            @if (form.controls.password.touched && form.controls.password.invalid) {
              <small class="text-danger">A palavra-passe é obrigatória.</small>
            }
          </div>

          @if (serverError()) {
            <div class="alert alert-danger">{{ serverError() }}</div>
          }

          <button class="btn btn-lg w-100 btn-primary mb-3" [disabled]="loading()">
            {{ loading() ? 'Entrando…' : 'Entrar' }}
          </button>

          <div class="text-center">
            <!-- Quem se esquece da palavra-passe ficava a olhar para o ecrã sem saber o que
                 fazer. Não há recuperação por e-mail; quem repõe o acesso é o administrador da
                 empresa, em Configurações → Utilizadores → Repor acesso. -->
            <small class="text-muted d-block mb-2">
              Esqueceu-se da palavra-passe? Peça ao administrador da sua empresa que reponha o
              seu acesso — recebe um link para definir uma nova.
            </small>
            <small class="text-muted">
              A sua empresa ainda não usa o sistema?
              <a routerLink="/solicitar-acesso">Solicitar acesso</a>.
            </small>
          </div>
        </form>
      </div>
    </div>
  </div>
</div>
